// extracted by mini-css-extract-plugin
export default {"question_content_scroll":"AddNewBox_question_content_scroll__ECcwd","question_title_scroll":"AddNewBox_question_title_scroll__PNkUT","active":"AddNewBox_active__feCoG"};